import { useTiktokUserAnalytics } from 'Modules/Influencer/hooks/queries/useTiktokUserAnalytics';
import { ClientInfluencerAccount } from './helpers';
import { useInstagramUserAnalytics } from 'Modules/Influencer/hooks/queries/useInstagramUserAnalytics';

export default function useUserAnalytics(
    account: ClientInfluencerAccount | undefined | null,
    { enabled = true }: { enabled: boolean }
) {
    const { platform, creatorbase_user_id: userId } = account ?? {};

    const tiktokAnalytics = useTiktokUserAnalytics(userId, {
        enabled: platform === 'tiktok' && enabled,
        select: (data) => data.data,
    });

    const instagramAnalytics = useInstagramUserAnalytics(userId, {
        enabled: platform === 'instagram' && enabled,
        select: (data) => data.data,
    });

    return platform === 'tiktok' ? tiktokAnalytics : instagramAnalytics;
}
